<template>
  <v-expansion-panels v-model="contactPersonsPanel">
    <v-expansion-panel>
      <alert-error :error="error" />

      <v-expansion-panel-header class="text-h6 font-weight-regular">
        <v-row>
          <v-col md="auto">
            {{ $t('CONTACT_PERSONS.ITEMS') }}
          </v-col>
          <v-spacer />
          <v-col md="auto">
            <v-btn
              class="mr-4"
              color="indigo"
              outlined
              @click="createContactPerson"
            >
              <v-icon left>mdi-plus</v-icon>
              {{ $t('ITEM.NEW') }} {{ $t('CONTACT_PERSONS.ITEM') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <contact-persons-list :contact-persons="items">
          <template v-slot:actions="{ item }">
            <menu-of-actions
              :item="item"
              :menu="['view', 'delete']"
              @view="viewContactPerson"
              @delete="deleteContactPerson"
            />
          </template>
        </contact-persons-list>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-dialog v-model="dialog" persistent max-width="1000px">
      <template v-if="action">
        <component
          :is="component"
          :id="contactPersonId"
          :key="contactPersonId"
          :company="company"
          @created="closeAndRefresh"
          @updated="closeAndRefresh"
          @cancel="cancelDialog"
        ></component>
      </template>
    </v-dialog>

    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-expansion-panels>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ContactPersons',

  components: {
    ContactPersonsList: () => import('./ContactPersonsList'),
    CreateContactPerson: () => import('./CreateContactPerson'),
    ViewContactPerson: () => import('./ViewContactPerson'),
    MenuOfActions: () => import('@/modules/_global/_components/MenuOfActions'),
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog'),
    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  props: {
    company: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    items: [],
    error: null,
    action: null,
    dialog: false,
    contactPersonsPanel: null,
    expansionPanel: 1
  }),

  computed: {
    component() {
      return `${this.action}-contact-person`;
    }
  },

  mounted() {
    this.refresh();
  },

  methods: {
    ...mapActions('contact_person', [
      'getContactsPersonsCompany',
      'destroyBlockTask'
    ]),

    viewContactPerson({ id }) {
      this.action = 'view';
      this.contactPersonId = id;
      this.showDialog();
    },

    createContactPerson() {
      this.action = 'create';
      this.showDialog();
    },

    deleteContactPerson({ id }) {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            this.destroyBlockTask({ contactPersonId: id }).then(() => {
              this.refresh();
            });
          }
        });
    },

    closeAndRefresh() {
      this.refresh();
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.action = null;
      this.contactPersonId = null;
    },

    showDialog() {
      this.dialog = true;
    },

    refresh() {
      this.getContactsPersonsCompany({ companyId: this.id })
        .then(({ data }) => {
          this.items = data.data;
        })
        .catch(error => {
          this.error = error.response;
        });
    }
  }
};
</script>
